module.exports = __webpack_public_path__ + "static/media/tumorLocations.b1b33efd.PNG";